import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, nextTick } from "vue";
import { useSdkStore } from "@/stores/sdk";
import { initSdk } from "@/sdk/init";
import { setfontList } from "@/common/design";
import { useRouter, useRoute } from "vue-router";
import { initDesign } from '@/common/initDesign'
//@ts-ignore
import orderMseeage from '@/components/orderMseeage.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'design',
  setup(__props) {

const router = useRouter();
const route = useRoute()
const sdkStore = useSdkStore();
onMounted(async () => {
  await nextTick();
  const desginsdk = await initSdk("#page");
  sdkStore.setSdk(desginsdk);
  await setfontList()
  initDesign()
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "page" }, null, -1)),
    _createVNode(orderMseeage)
  ], 64))
}
}

})